import React, { useState, useEffect } from 'react';
import { useQuery, useApolloClient } from 'react-apollo';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Checkbox from '@material-ui/core/Checkbox';

import { makeStyles } from '@material-ui/core/styles';
import useSnack from 'hooks/useSnack';
import Input from 'components/form/Input';
import Button from 'components/common/Button';
import Spin from 'components/common/Spin';
import { SEARCH_STUDENT } from 'graphql/admin/students';
import { GET_STUDENT_MILESTONES } from 'graphql/admin/students';
import { GET_TEMPLATES } from 'graphql/timeline-templates';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 460,
    backgroundColor: theme.palette.background.paper,
  },
}));

const ImportStudent = ({ onImport, onCancel }) => {
  const classes = useStyles();
  const [selected, setSelected] = useState();
  const [milestones, setMilestones] = useState([]);
  const { data, loading } = useQuery(GET_TEMPLATES);

  useEffect(() => {
    setMilestones([]);
  }, [selected]);

  const handleImport = async () => {
    onImport({
      name: selected.name,
      data: milestones
    });
  };

  const handleToggle = (value) => () => {
    const currentIndex = milestones.indexOf(value);
    const newChecked = [...milestones];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setMilestones(newChecked);
  };

  if (loading) return <Spin linear spinning />;

  return (
    <div>
      <Grid container spacing={1} alignItems={'flex-end'}>
        <Grid item>
          <Button onClick={onCancel}>Cancel</Button>{' '}
          <Button
            variant="contained"
            color="primary"
            onClick={handleImport}
            disabled={!milestones.length}
          >
            Import Selected
          </Button>
        </Grid>
      </Grid>
      <br />

      <Grid container spacing={3}>
        <Grid item md={6}>
          <List
            disablePadding
            className={classes.root}
            subheader={<ListSubheader disableSticky>Select Template</ListSubheader>}
          >
            {data.rows.map((s) => (
              <ListItem
                divider
                button
                selected={s === selected}
                onClick={() => setSelected(s)}
                key={s.id}
              >
                <ListItemText primary={s.name} />
              </ListItem>
            ))}
          </List>
        </Grid>
        <Grid item md={6}>
          { selected && (
            <List
              disablePadding
              className={classes.root}
              subheader={<ListSubheader disableSticky>Select Milestone(s)</ListSubheader>}
            >
              {selected.data.map((i) => (
                <ListItem
                  divider
                  button
                  onClick={handleToggle(i)}
                  key={i.id}
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={milestones.indexOf(i) !== -1}
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText primary={i.name} />
                </ListItem>
              ))}
            </List>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default ImportStudent;
